import React from 'react';
import {
  View,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { feedbackStrings } from '@/constants/residents/marketplaceStrings';
import { FeedbackItem } from '@/types/residents/marketplaceListing';
import { FeedbackCard } from './FeedbackCard';
import { BaseModal } from './shared';
import { MarketplaceEmptyState } from './MarketplaceEmptyState';

interface FeedbackModalProps {
  visible: boolean;
  onClose: () => void;
  feedbackItems: FeedbackItem[];
}

export const FeedbackModal: React.FC<FeedbackModalProps> = ({
  visible,
  onClose,
  feedbackItems,
}) => {
  return (
    <BaseModal
      visible={visible}
      onClose={onClose}
      title={feedbackStrings.receivedFeedback}
      scrollable={true}
      headerStyle={styles.header}
    >
      {/* Feedback List */}
      <View style={styles.listContent}>
        {feedbackItems.map((feedback, index) => (
          <FeedbackCard
            key={feedback.id}
            feedback={feedback}
            showDivider={index < feedbackItems.length - 1}
          />
        ))}

        {feedbackItems.length === 0 && (
          <MarketplaceEmptyState
            title={feedbackStrings.noFeedbackReceived}
            style={{ paddingVertical: 40 }}
          />
        )}
      </View>
    </BaseModal>
  );
};

const styles = StyleSheet.create({
  header: {
    borderBottomWidth: 1,
    borderBottomColor: MARKETPLACE_COLORS.dividerGray,
  },
  listContent: {
    paddingTop: 10,
  },
});
